import { parse } from 'querystring'

// FIXME improve this when we can use to= https://github.com/zeit/next.js/issues/8207

/**
 * Determines href/as for url if possible for Link
 * @param {string} path
 * @return {string} returns pathname string
 */
function pathToHrefAs (path: string) {
  const [pathPart, queryPart] = path.toLowerCase().split('?')
  const pathParts = pathPart.split('/')
  const query = parse(queryPart)
  const href = { pathname: pathPart, query }
  const as = { pathname: pathPart, query }

  if (path.startsWith('/news/')) {
    if (pathParts[2] === 'topics') {
      href.pathname = '/news/topics/[id]'
      as.pathname = `/news/topics/${pathParts[3]}`
    } else {
      href.pathname = '/news/[id]'
      as.pathname = `/news/${pathParts[2]}`
    }
  } else if (path.startsWith('/resources/')) {
    if (pathParts[2] === 'topics') {
      href.pathname = '/resources/topics/[id]'
      as.pathname = `/resources/topics/${pathParts[3]}`
    } else {
      href.pathname = '/resources/[id]'
      as.pathname = `/resources/${pathParts[2]}`
    }
  } else if (path.startsWith('/reports/')) {
    href.pathname = '/reports/[slug]'
    as.pathname = `/reports/${pathParts[2]}`
  } else if (path.startsWith('/support/faqs/')) {
    if (pathParts[3] === 'topics') {
      href.pathname = '/support/faqs/topics/[id]'
      as.pathname = `/support/faqs/topics/${pathParts[4]}`
    } else {
      href.pathname = '/support/faqs/[id]'
      as.pathname = `/support/faqs/${pathParts[3]}`
    }
  } else if (path.startsWith('/support/contacts/')) {
    href.pathname = '/support/contacts/[id]'
    as.pathname = `/support/contacts/${pathParts[3]}`
  } else if (path.startsWith('/support/office-locations/')) {
    if (pathParts[4]) {
      if (pathParts[4] === 'conference-rooms' && pathParts[5]) {
        href.pathname = `/support/office-locations/[id]/${pathParts[4]}/[roomId]`
        as.pathname = `/support/office-locations/${pathParts[3]}/${pathParts[4]}/${pathParts[5]}`
      } else {
        href.pathname = `/support/office-locations/[id]/${pathParts[4]}`
        as.pathname = `/support/office-locations/${pathParts[3]}/${pathParts[4]}`
      }
    } else {
      href.pathname = '/support/office-locations/[id]'
      as.pathname = `/support/office-locations/${pathParts[3]}`
    }
  }

  return { href, as }
}

export { pathToHrefAs }
